import posthog from 'posthog-js';
import { posthogEnabled } from '$lib/utils/posthog.js';

/** @type {import('@sveltejs/kit').HandleClientError} */
export function handleError({ error, status }) {
	if (status !== 404 && posthogEnabled) {
		posthog.captureException(error);
	}
}
